import script from "./AuditlogsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditlogsModal.vue?vue&type=script&lang=ts&setup=true"

import "./AuditlogsModal.vue?vue&type=style&index=0&id=bbf74246&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbf74246"]])

export default __exports__